import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchInventoryLocationOptions,
  fetchInventoryLocationZoneOptions,
  fetchInventoryDonorOptions,
  adjustInventoryItem,
  adjustInventoryPackage
} from '../../../sagas/routines';

const initialState = {
  locationOptions: {},
  locationZoneOptions: {},
  donorOptions: {},
  fetchingLocationOptions: false,
  fetchedLocationOptions: false,
  fetchingLocationOptionsError: null,
  fetchingLocationZoneOptions: false,
  fetchedLocationZoneOptions: false,
  fetchingLocationZoneOptionsError: null,
  fetchedDonorOptions: false,
  fetchingDonorOptions: false,
  fetchingDonorOptionsError: null,
  saving: false,
  saved: false,
  savingError: null
};

const fetchLocationOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetchingLocationOptions: true,
    fetchedLocationOptions: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('locationOptions', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingLocationOptions: false,
    fetchedLocationOptions: true
  })
});

const fetchLocationZoneOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetchingLocationZoneOptions: true,
    fetchedLocationZoneOptions: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('locationZoneOptions', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingLocationZoneOptions: false,
    fetchedLocationZoneOptions: true
  })
});

const fetchDonorOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetchingDonorOptions: true,
    fetchedDonorOptions: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('donorOptions', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingDonorOptions: false,
    fetchedDonorOptions: true
  })
});

const adjustItemHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: set('saved', true),
  [routine.FAILURE]: (state, error) => set('savingError', error, state),
  [routine.FULFILL]: set('saving', false)
});

const adjustPackageHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: set('saved', true),
  [routine.FAILURE]: (state, error) => set('savingError', error, state),
  [routine.FULFILL]: set('saving', false)
});

export default createReducer(initialState, {
  ...fetchLocationOptionsHandler(fetchInventoryLocationOptions),
  ...fetchLocationZoneOptionsHandler(fetchInventoryLocationZoneOptions),
  ...fetchDonorOptionsHandler(fetchInventoryDonorOptions),
  ...adjustItemHandler(adjustInventoryItem),
  ...adjustPackageHandler(adjustInventoryPackage)
});
